import { ChangeDetectionStrategy, Component } from '@angular/core';
import { MessageService } from './message.service';

@Component({
  selector: 'bm-ext-message',
  templateUrl: './message.component.html',
  styleUrls: ['./message.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class MessageComponent {

  readonly message$ = this.messageService.message$;

  constructor(private readonly messageService: MessageService) {}

}
